import { createSlice } from "@reduxjs/toolkit";
import {
  cartProductCount,
  getCartProducts,
} from "../../reduxApi/website/CartProductCount";
import { getCategoriesFullData } from "../../reduxApi/website/getCategoriesFullData";

const getCategoriesFullDataSlice = createSlice({
  name: "CartCount",
  initialState: {
    status: "idle",
    getCategoriesFullData: [],

    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCategoriesFullData.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.getCategoriesFullData = action.payload.data;
      console.log("getCategoriesFullData ", state.getCategoriesFullData);
    });
  },
});

export default getCategoriesFullDataSlice.reducer;
